import { Component, Input, WritableSignal } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { IrProcessHistoryResultComponent } from '../service/ir-process-history/ir-process-history-result/ir-process-history-result.component';
import { ReadingRoomSubmissionInitialValuesModalComponent } from '../service/reading-room-submission-versions/reading-room-submission-initial-values-modal/reading-room-submission-initial-values-modal.component';
import { TooltipComponent } from '../tooltip/tooltip.component';

@Component({
  selector: 'app-card-table',
  standalone: true,
  imports: [TooltipComponent, TranslateModule, ReadingRoomSubmissionInitialValuesModalComponent, IrProcessHistoryResultComponent],
  templateUrl: './card-table.component.html',
  styleUrl: './card-table.component.scss'
})
export class CardTableComponent<TRow> {
  @Input() config!: CardTableConfig<TRow>;

  getPropertyValueAsString(item: TRow, key: keyof TRow) {
    return String(item[key]);
  }
}

export interface CardTableConfig<TRow> {
  data: WritableSignal<TRow[]>;
  columns: CardTableColumn<TRow>[];
  headerTitle?: string;
  headerTitleTooltip?: string;
  headerActions?: CardTableHeaderAction[];
  footerActions?: CardTableFooterAction[];
}

export type CardTableColumn<TRow> = CardTableColumnByProperty<TRow>;

export type CardTableHeaderAction = CardTableAction;
export type CardTableFooterAction = CardTableAction;

type CardTableBaseAction = {
  title: string;
};

type CardTableLinkAction = CardTableBaseAction & {
  type: 'link';
  href: string;
  onClick?: never;
};

type CardTableButtonAction = CardTableBaseAction & {
  type: 'button';
  onClick: () => void;
  href?: never;
};

type CardTableAction = CardTableLinkAction | CardTableButtonAction;

interface CardTableColumnBase {
  title: string;
  tooltip?: string;
}

interface CardTableColumnByProperty<TRow> extends CardTableColumnBase {
  convert?: (row: TRow) => string;
  propertyName?: keyof TRow;
  getter?: (row: TRow) => SafeHtml;
  customLogic?: 'ValueCompare' | 'IrChangeResult';
}
